import React from "react";

// Mirrors the real Objective row's layout rather than a spinner or a
// "Loading…" line, per CLAUDE.md — same standard `AnnualOkrSkeleton` and
// `ExecutionBlueprintReviewMode`'s own placeholder set.
const AnnualOkrReviewSkeleton = ({ count = 3 }) => (
  <div className="aokr-mode" aria-hidden="true">
    <div className="aokr-items">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="aokr-item aokr-item--sk">
          <div className="aokr-sk aokr-sk--statement" />
          <div className="aokr-sk aokr-sk--kr" />
          <div className="aokr-sk aokr-sk--kr aokr-sk--short" />
        </div>
      ))}
    </div>
  </div>
);

export default AnnualOkrReviewSkeleton;
